export default __webpack_public_path__ + "static/media/faq-empty.24055d89.svg";